import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getPostalFolders = async (data) => {
    return decryptData(
        await axios.get(
            `/get-postal-folders?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};


export const createPostalContentFolder = async (data) => {
    return decryptData(
        await axios.post(`/create-postal-content-folder`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const renameFolder = async (data) => {
    return decryptData(
        await axios.post(`/rename-folder`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};


// sub page list
export const getPostalFolderContent = async (data) => {
    return decryptData(
        await axios.get(
            `/get-postal-folder-content?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};




export const uploadFilesInPostalDocument = async (data) => {
    return decryptData(
        await axios.post(`upload-files-in-postal-document`, data, setMultiPartHeader())
    );
};


export const renameFile = async (data) => {
    return decryptData(
        await axios.post(`/rename-file`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const deleteFolderFromPostalDocs = async (data) => {
    return decryptData(
        await axios.post(`/delete-folder-from-postaldocs`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};
